import moment from 'moment-timezone'


export function daysFromPeriod(
  dateFrom: string | null,
  dateTo: string | null,
  dateFormat: string,
) {
  const res = {} as Record<string, string>
  if (dateFrom && dateTo) {
    const mFrom = moment(dateFrom, dateFormat)
    const mTo = moment(dateTo, dateFormat)
    for (let index = 0; index <= 1000; index += 1) {
      const date = mFrom.format(dateFormat)
      res[date] = date
      if (mFrom.isSame(mTo)) break
      mFrom.add(1, 'day')
    }
  }
  if (dateFrom) {
    res[dateFrom] = dateFrom
  }
  if (dateTo) {
    res[dateTo] = dateTo
  }
  return res
}
